import React, { useState } from 'react';
import { setLoadContacts } from '../../truckmateStore';

const looksLikeEmail = (e) => /^[^\s@,;]+@[^\s@,;]+\.[a-z]{2,}$/i.test(e);

// Who gets the customer emails on this load: erase a wrong one, add the right one. Saved for the broker (or bill-to), so their
// next loads use the fixed list too.
export default function CustomerEmails({ trip, emails, company, outlook = true, onSaved }) {
  const [list, setList] = useState(emails);
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const changed = list.join(',').toLowerCase() !== emails.join(',').toLowerCase();
  const add = () => {
    const e = typed.trim();
    if (!e) return;
    if (!looksLikeEmail(e)) { setMsg('That is not an email address.'); return; }
    if (!list.some((x) => x.toLowerCase() === e.toLowerCase())) setList([...list, e]);
    setTyped(''); setMsg('');
  };
  const save = async () => {
    setBusy(true); setMsg('');
    try { const r = await setLoadContacts(trip, list); setList(r.emails); setMsg(`Saved for ${r.company}. Their next loads use this list.`); if (onSaved) onSaved(r); } catch (ex) { setMsg(ex.message || 'Could not save.'); } finally { setBusy(false); }
  };
  return (
    <div className="tmw-small" aria-label="Customer emails">
      <b>Email</b> ({list.length}){!outlook && list.length ? ' · Outlook not connected yet — will not send' : ''}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
        {!list.length && <span>No customer emails on file.</span>}
        {list.map((e) => (
          <span key={e} className="tmw-chip" style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            {e}
            <button type="button" aria-label={`Erase ${e}`} onClick={() => setList(list.filter((x) => x !== e))} style={{ border: 0, background: 'none', cursor: 'pointer', fontSize: 15, lineHeight: 1, padding: '0 2px' }}>×</button>
          </span>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
        <input type="email" value={typed} onChange={(e) => setTyped(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }} placeholder="Add an email" aria-label="Add an email" style={{ flex: 1 }} />
        <button type="button" className="tmw-btn tmw-btn-sm" onClick={add} disabled={!typed.trim()}>Add</button>
      </div>
      {changed && <button type="button" className="tmw-btn tmw-btn-sm tmw-btn-primary" style={{ marginTop: 6 }} onClick={save} disabled={busy}>{busy ? 'Saving…' : `Save these emails${company ? ` for ${company}` : ''}`}</button>}
      {msg && <div role="status" style={{ marginTop: 4 }}>{msg}</div>}
    </div>
  );
}
